import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no 7+ hour drive to Houston",
      "Ideal for Tulsa energy executives on overseas assignments",
      "Perfect for ORU and TU students studying abroad",
      "Great for church mission groups deploying internationally",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Tulsa County post offices",
      "Good for planned international trips from TUL",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Tulsa area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Houston — ~500 miles via I-44/I-45",
      "Oklahoma has ZERO passport agencies — no in-state option exists",
      "NPIC appointment required before driving to Houston",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect a full-day commitment and overnight if weather hits",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function TulsaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Tulsa"
      headingExtra="OK"
      introText="Tulsa and Northeast Oklahoma travelers — energy sector executives flying to Middle East and South American oil fields on 48-hour notice, Oral Roberts University and University of Tulsa students heading to semester-abroad programs, church mission groups deploying to Central America and Africa, aerospace manufacturing engineers from Tulsa's American Airlines maintenance base traveling to international facilities, and TUL flyers heading to Mexico and the Caribbean — have several options for getting a passport fast. Here is how they compare, and why most Green Country residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 7+ hour drive to Houston."
      options={options}
      emergencyDescription="Oklahoma has ZERO passport agencies — the state's 4M+ residents have no in-state emergency option whatsoever. The closest agency is Houston, roughly 500 miles south via I-44 and I-45, a 7+ hour drive. Spring tornado season (March–June) makes I-44 between Tulsa and Oklahoma City one of the most dangerous highway corridors in America — EF-3+ tornadoes have crossed I-44 repeatedly, shutting down the interstate entirely. An ORU mission group deploying to Guatemala, or a Williams Companies engineer flying to an LNG facility in the Netherlands on 48 hours' notice, cannot wait for I-44 to reopen after a tornado event."
      disclaimerText="*Processing speed depends on eligibility and documentation. Oklahoma has ZERO passport agencies — the closest is Houston, roughly 500 miles and 7+ hours away via I-44/I-45 through Tornado Alley. Not all applicants qualify for Regional Agency Processing."
    />
  );
}